<div class="m-0 p-1" style="min-height: 260px; max-height: 260px;">
  <div>
    <button
      mat-raised-button
      color="primary"
      class="mt-1 mb-2"
      (click)="addContato()"
    >
      Adicionar Contato
    </button>
  </div>
  <mat-divider></mat-divider>
  <ng-template #notLenght>
    <div
      style="height: 200px; display: flex; justify-content: center; align-items: center;"
    >
      <div
        style="color: #999; display: flex; justify-content: center; align-items: center; flex-direction: column;"
      >
        <mat-icon
          style="width: 38px; height: 38px; font-size: 38px; margin-bottom: 21px;"
          >phone_disabled</mat-icon
        >
        <p style="font-size: 16px; text-align: center;">
          Nenhum contato cadastrado
        </p>
      </div>
    </div>
  </ng-template>
  <ng-template #list>
    <mat-nav-list class="d-flex flex-wrap mb-2">
      <mat-list-item
        class="col-md-6"
        (click)="editarContato(contato, i)"
        *ngFor="let contato of entityTemp.contatos; let i = index"
      >
        <mat-icon matListIcon>phone</mat-icon>
        <h3 matLine>{{ contato.contato }}</h3>
        <p matLine>{{ formatarTags(contato.tag) }}</p>
        <button
          (click)="removerContato($event, contato)"
          type="button"
          mat-icon-button
        >
          <mat-icon>delete</mat-icon>
        </button>
      </mat-list-item>
    </mat-nav-list>
  </ng-template>
  <ng-container
    [ngTemplateOutlet]="entity.contatos.length > 0 ? list : notLenght"
  ></ng-container>
</div>
